<!-- Listado de Centros — nuevo diseño (ui-redesign). Estilos en design-system (.ds / _listado). -->
<div class="ds opx">
	<div class="wrap">
		<section class="sheet has-art" style="margin-top: 6px; padding: 22px 26px 26px">
			<div class="list-art" style="background-image: url('/assets/fondos/hero_sites_bg.webp')"></div>

			<div class="opx-head">
				<span class="opx-ic"><lord-icon trigger="hover" src="/assets/icons/sections/sites.json"></lord-icon></span>
				<div class="opx-head-tx">
					<p class="eyebrow">{{ "lst.centros.eyebrow" | translate }}</p>
					<h1 class="opx-title">{{ "header.menu.sites" | translate }}</h1>
					<p class="opx-sub">{{ "lst.centros.subtitle" | translate }}</p>
				</div>
			</div>

			<div class="opx-kpis">
				<div class="opx-kpi">
					<span class="opx-kpi-ic ic-total"><mat-icon>apartment</mat-icon></span>
					<div class="opx-kpi-tx"><div class="opx-kpi-big">{{ kpiTotal }}</div><div class="opx-kpi-lbl">{{ "lst.kpi.total" | translate }}</div></div>
				</div>
				<div class="opx-kpi">
					<span class="opx-kpi-ic ic-done"><mat-icon>check_circle</mat-icon></span>
					<div class="opx-kpi-tx"><div class="opx-kpi-big">{{ kpiActive }}</div><div class="opx-kpi-lbl">{{ "lst.kpi.active" | translate }}</div></div>
				</div>
				<div class="opx-kpi">
					<span class="opx-kpi-ic ic-gray"><mat-icon>do_not_disturb_on</mat-icon></span>
					<div class="opx-kpi-tx"><div class="opx-kpi-big">{{ kpiInactive }}</div><div class="opx-kpi-lbl">{{ "lst.kpi.inactive" | translate }}</div></div>
				</div>
				<div class="opx-kpi">
					<span class="opx-kpi-ic ic-info"><mat-icon>factory</mat-icon></span>
					<div class="opx-kpi-tx"><div class="opx-kpi-big">{{ kpiTypes }}</div><div class="opx-kpi-lbl">{{ "lst.kpi.types" | translate }}</div></div>
				</div>
			</div>

			<div class="lst">
				<div class="lst-filters opx-filters">
					<div class="lst-search">
						<span class="ic"><mat-icon>search</mat-icon></span>
						<input #q type="text" [value]="searchText" (input)="onSearchChange(q.value)" placeholder="{{ 'lst.searchPlaceholder' | translate }}" />
					</div>
					<select class="lst-select" #actividadSel (change)="onActividadChange(actividadSel.value)">
						<option value="">{{ "lst.filter.activity" | translate }}: {{ "lst.all" | translate }}</option>
						<option *ngFor="let o of actividadOptions" [value]="o" [selected]="o === selectedActividad">{{ o }}</option>
					</select>
					<select class="lst-select" #insSel (change)="onInstalacionChange(insSel.value)">
						<option value="">{{ "lst.filter.type" | translate }}: {{ "lst.all" | translate }}</option>
						<option *ngFor="let o of instalacionOptions" [value]="o" [selected]="o === selectedInstalacion">{{ o }}</option>
					</select>
					<select class="lst-select" #actSel (change)="onActivoChange(actSel.value)">
						<option value="">{{ "lst.filter.status" | translate }}: {{ "lst.all" | translate }}</option>
						<option value="true" [selected]="selectedActivo === 'true'">{{ "lst.col.active" | translate }}</option>
						<option value="false" [selected]="selectedActivo === 'false'">{{ "lst.col.inactive" | translate }}</option>
					</select>
					<button *ngIf="hasActiveFilters" class="opx-clear" (click)="clearFilters()" matTooltip="{{ 'lst.clear' | translate }}"><span class="ic"><mat-icon>filter_alt_off</mat-icon></span></button>
				</div>

				<div class="lst-topbar">
					<span class="cnt"><b>{{ filtered.length }}</b> {{ "header.menu.sites" | translate | lowercase }}</span>
					<div style="display: flex; align-items: center; gap: 10px">
						<app-utils-menu>
							<button type="button" class="utils-item" (click)="exportToExcel()" [disabled]="isExportingExcel || filtered.length === 0">
								<mat-icon class="ic">table_view</mat-icon>
								<span>{{ "lst.utils.exportExcel" | translate }}</span>
							</button>
						</app-utils-menu>
						<div class="seg opx-seg">
							<button [class.on]="viewMode === 'table'" (click)="viewMode = 'table'"><span class="ic"><mat-icon>table_rows</mat-icon></span>{{ "lst.view.table" | translate }}</button>
							<button [class.on]="viewMode === 'cards'" (click)="viewMode = 'cards'"><span class="ic"><mat-icon>grid_view</mat-icon></span>{{ "lst.view.cards" | translate }}</button>
						</div>
					</div>
				</div>

				<div class="table-card opx-table" *ngIf="viewMode === 'table'">
					<table class="ctr" [(dsSortTable)]="filtered">
						<thead>
							<tr>
								<th data-sort="descripcion">{{ "lst.col.description" | translate }}</th>
								<th data-sort="codigo">{{ "lst.col.code" | translate }}</th>
								<th data-sort="codigoContrato">{{ "lst.col.contract" | translate }}</th>
								<th data-sort="actividadContrato">{{ "lst.col.activity" | translate }}</th>
								<th data-sort="tipo_Instalacion">{{ "lst.col.type" | translate }}</th>
								<th data-sort="responsable_Planta_Nombre">{{ "lst.col.responsible" | translate }}</th>
								<th data-sort="activo">{{ "lst.col.status" | translate }}</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let c of paged; trackBy: trackById" (click)="onView(c)">
								<td><span class="opx-name">{{ c.descripcion || c.codigo }}</span><mat-icon *ngIf="c.esResponsable" class="opx-mine" matTooltip="{{ 'lst.youAreResponsibleSite' | translate }}" matTooltipClass="opx-tip" matTooltipPosition="above">assignment_ind</mat-icon></td>
								<td><app-contract-codes [contract]="{ codigo: c.codigo, codigoCorto: codigoCorto(c) }" titleKey="centro.codes.popTitle" mainLabelKey="centro.codes.codigo"><span class="opx-code">{{ c.codigo }}</span></app-contract-codes></td>
								<td>
									<span class="opx-badge st-contract" [class.is-link]="canViewContract" *ngIf="c.contratoId" (click)="onViewContract(c, $event)" [matTooltip]="c.descripcionContrato || ''" matTooltipClass="opx-tip" matTooltipPosition="above">{{ c.codigoContrato || ("lst.linked" | translate) }}</span>
									<span *ngIf="!c.contratoId" class="opx-muted">—</span>
								</td>
								<td class="opx-muted">{{ c.actividadContrato || "—" }}</td>
								<td class="opx-muted">{{ c.tipo_Instalacion }}</td>
								<td class="opx-muted">{{ c.responsable_Planta_Nombre | nameCase }}</td>
								<td><span class="opx-badge" [ngClass]="c.activo ? 'ok' : 'gray'">{{ (c.activo ? "lst.col.active" : "lst.col.inactive") | translate }}</span></td>
								<td><span class="opx-go ic"><mat-icon>chevron_right</mat-icon></span></td>
							</tr>
							<tr *ngIf="!isLoading && filtered.length === 0"><td colspan="8"><app-empty-state icon="search_off" tone="neutral" [title]="'lst.empty' | translate" [message]="'lst.emptyHint' | translate" [ctaLabel]="hasActiveFilters ? ('lst.clear' | translate) : ''" ctaIcon="filter_alt_off" (cta)="clearFilters()"></app-empty-state></td></tr>
							<tr *ngIf="isLoading"><td colspan="8" class="opx-empty">{{ "common.loading" | translate }}</td></tr>
						</tbody>
					</table>
				</div>

				<div class="grid-cards" *ngIf="viewMode === 'cards'">
					<article class="kcard opx-card" *ngFor="let c of paged; trackBy: trackById" (click)="onView(c)">
						<div class="kc-top">
							<div class="kc-em"><mat-icon>apartment</mat-icon></div>
							<div class="kc-id"><div class="kc-name">{{ c.descripcion || c.codigo }}<mat-icon *ngIf="c.esResponsable" class="opx-mine" matTooltip="{{ 'lst.youAreResponsibleSite' | translate }}" matTooltipClass="opx-tip" matTooltipPosition="above">assignment_ind</mat-icon></div><app-contract-codes [contract]="{ codigo: c.codigo, codigoCorto: codigoCorto(c) }" titleKey="centro.codes.popTitle" mainLabelKey="centro.codes.codigo"><div class="opx-code">{{ c.codigo }}</div></app-contract-codes></div>
						</div>
						<div class="kc-meta">
							<div class="kc-m"><span>{{ "lst.col.contract" | translate }}</span><b><span class="opx-badge st-contract" [class.is-link]="canViewContract" *ngIf="c.contratoId" (click)="onViewContract(c, $event)" [matTooltip]="c.descripcionContrato || ''" matTooltipClass="opx-tip" matTooltipPosition="above">{{ c.codigoContrato }}</span><ng-container *ngIf="!c.contratoId">—</ng-container></b></div>
							<div class="kc-m"><span>{{ "lst.col.activity" | translate }}</span><b>{{ c.actividadContrato || "—" }}</b></div>
							<div class="kc-m"><span>{{ "lst.col.type" | translate }}</span><b>{{ c.tipo_Instalacion }}</b></div>
							<div class="kc-m"><span>{{ "lst.col.responsible" | translate }}</span><b>{{ c.responsable_Planta_Nombre | nameCase }}</b></div>
						</div>
						<div class="kc-foot">
							<span class="opx-badge" [ngClass]="c.activo ? 'ok' : 'gray'">{{ (c.activo ? "lst.col.active" : "lst.col.inactive") | translate }}</span>
						</div>
					</article>
					<app-empty-state *ngIf="!isLoading && filtered.length === 0" icon="search_off" tone="neutral" [title]="'lst.empty' | translate" [message]="'lst.emptyHint' | translate" [ctaLabel]="hasActiveFilters ? ('lst.clear' | translate) : ''" ctaIcon="filter_alt_off" (cta)="clearFilters()"></app-empty-state>
				</div>

				<div class="pager" *ngIf="totalPages > 1">
					<div class="pg-info">{{ page }} / {{ totalPages }}</div>
					<div class="pg-ctrls">
						<button class="pgbtn" [disabled]="page === 1" (click)="goToPage(1)"><span class="ic"><mat-icon>first_page</mat-icon></span></button>
						<button class="pgbtn" [disabled]="page === 1" (click)="goToPage(page - 1)"><span class="ic"><mat-icon>chevron_left</mat-icon></span></button>
						<button class="pgbtn" [disabled]="page === totalPages" (click)="goToPage(page + 1)"><span class="ic"><mat-icon>chevron_right</mat-icon></span></button>
						<button class="pgbtn" [disabled]="page === totalPages" (click)="goToPage(totalPages)"><span class="ic"><mat-icon>last_page</mat-icon></span></button>
					</div>
				</div>
			</div>
		</section>
	</div>
</div>
